export const setContract = 'setContract'
export const setContracts = 'setContracts'
export const setContractPlan = 'setContractPlan'
export const setContractAfterInactive = 'setContractAfterInactive'
export const setFilterContract = 'setFilterContract'
export const setFilteredPlans = 'setFilteredPlans'
export const clearFilteredPlans = 'clearFilteredPlans'
export const clearFilterCustomers = 'clearFilterCustomers'
export const clearFilterContract = 'clearFilterContract'
export const clearFilterContracts = 'clearFilterContracts'
export const changeContractPlan = 'changeContractPlan'



// WEBPACK FOOTER //
// ./src/app/pages/contracts/vuex/mutations-types.js